import { useState, useEffect, useCallback } from 'react';
import { searchBillingCodeConfig } from 'api/insuranceBilling';
import { getOpsBillingCodeConfig } from 'api/operation';
import { TBillingCodeConfig } from 'types/insuranceBilling';

const globalCache: Record<string, TBillingCodeConfig[]> = {};

const useCPTCodeOptions = (specialty?: string, isOps?: boolean, providerId?: number): [TBillingCodeConfig[], boolean, () => void] => {
    const cacheKey = `${specialty || '__default__'}__${providerId || ''}`;
    const [data, setData] = useState<TBillingCodeConfig[]>(globalCache[cacheKey] || []);
    const [loading, setLoading] = useState(!globalCache[cacheKey]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = isOps
                ? await getOpsBillingCodeConfig('CPT', specialty, providerId)
                : await searchBillingCodeConfig('CPT', specialty);
            if (res && !res.error) {
                const list = res.data?.data || [];
                globalCache[cacheKey] = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [cacheKey, specialty, isOps, providerId]);

    useEffect(() => {
        if (!globalCache[cacheKey]) {
            fetchData();
        }
    }, [fetchData, cacheKey]);

    return [data, loading, fetchData];
};

export default useCPTCodeOptions;
